import { dataCustomerService } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCustomerService = /*#__PURE__*/createIcon(dataCustomerService)
export default IconCustomerService
